import { BetaPage } from "./BetaPage";
import { RedeemLanding } from "./RedeemLanding";

// Routes (no router lib — two top-level shapes is enough):
//   /<slug>      app's beta page (full marketing surface + claim CTA)
//   /r/<code>    redeem landing — what the QR on the desktop page
//                  encodes. Mobile-friendly, deeplinks into the app
//                  if installed.
export default function App() {
  const segments = window.location.pathname
    .replace(/^\/+|\/+$/g, "")
    .split("/");

  if (segments[0] === "r" && segments[1]) {
    return <RedeemLanding code={segments[1]} />;
  }

  const slug = segments[0];
  if (!slug) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <h1 className="text-2xl font-bold text-[var(--color-ink)]">
          Gentle Motion Beta
        </h1>
        <p className="mt-2 text-[var(--color-muted)]">
          Visit <code className="font-mono">/&lt;app-slug&gt;</code> for an
          app's beta page.
        </p>
      </div>
    );
  }
  return <BetaPage slug={slug} />;
}
